import { connect } from 'react-redux';

import { billOverviewActions } from 'dataflow/billingPortal/actions';

import { BillOverviewPresentation } from './BillOverviewPresentation';

function mapStateToProps(state) {
    const { getSpecificInvoiceDetails_requesting, specificInvoiceDetails } = state.billOverviewReducers;

	return {
        getSpecificInvoiceDetails_requesting,
        specificInvoiceDetails,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getSpecificInvoiceDetails: (invoiceNo) => { dispatch(billOverviewActions.getSpecificInvoiceDetails(invoiceNo)); }
    };
}

const BillOverview = connect(mapStateToProps, mapDispatchToProps)(BillOverviewPresentation);

export default BillOverview;